import { css } from "@emotion/react";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const textSmall = css`
  font-size: 13px;
  line-height: 1.23;
  font-weight: 400;
`;

export const textNormal = css`
  font-size: 15px;
  line-height: 1.83;
  font-weight: 400;
`;

export const textLarge = css`
  font-size: 18px;
  line-height: 24px;
`;

export const textExtraLarge = css`
  font-size: 24px;
  line-height: 32px;
`;

export const textPrimary = css`
  color: ${withVar(DesignToken.ContentBasicPrimary)};
`;

export const textBolded = css`
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  font-weight: 600;
`;

export const textMuted = css`
  font-weight: normal;
  color: ${withVar(DesignToken.ContentBasicDisabled)};
`;
